import { render } from "./IconMessageCircle.vue.js?vue&type=template&id=93c4cd8e!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconMessageCircle.vue?vue&type=template&id=93c4cd8e"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__